// extracted by mini-css-extract-plugin
module.exports = {"container":"Shared_container__DLsnf"};